module.exports = __webpack_public_path__ + "static/media/Fontisto.b49ae8ab.ttf";